import * as e from "react";
import r from "../lib/IconBase.es.js";
import n from "../defs/NotePencil.es.js";
const o = e.forwardRef((t, c) => /* @__PURE__ */ e.createElement(r, { ref: c, ...t, weights: n }));
o.displayName = "NotePencilIcon";
const m = o;
export {
  m as NotePencil,
  o as NotePencilIcon
};
